import { Link } from 'react-router-dom';
import { useAppSettings } from '../../context/AppSettingsContext';
import { DatabaseSoundPackModel } from '../../services/DatabaseSoundPack';
import { DatabaseSettingsModel } from '../../services/DatabaseSettings';

// Inline All-Access upsell shown under the cart's Browse Packs rail while the
// user isn't subscribed. Beige card; on hover a blue radial glow fades up,
// swells and slowly drifts, and the price warms to white. Links to the
// subscribe buy step.
//
// Price is the yearly plan's per-month rate — the cheapest, hence "from" — from
// the live Firestore value (settings/settings), same source as the Subscribe
// page and the Account CTA; '7.99' is only a first-paint fallback.
export function AllAccessBanner() {
    const { settings } = useAppSettings();
    const priceLabel = DatabaseSoundPackModel.formatPrice(DatabaseSettingsModel.yearlyMonthlyPrice(settings) ?? '7.99');

    return (
        <Link
            to="/subscribe"
            className="group relative mt-2.5 block overflow-hidden rounded-btn bg-[#F4F3EE]"
        >
            <span
                aria-hidden
                className="pointer-events-none absolute -inset-[20%] scale-90 bg-[radial-gradient(60%_90%_at_50%_50%,#6789A1_0%,#A8B4BC_55%,transparent_100%)] bg-[length:180%_180%] bg-center opacity-10 transition-[opacity,transform] duration-[2200ms] ease-out group-hover:scale-[1.15] group-hover:animate-aadrift group-hover:opacity-40"
            />
            <div className="relative flex flex-wrap items-end justify-between gap-4 px-5 py-6.5 sm:px-7">
                <div className="flex flex-col">
                    <span className="text-[11px] font-semibold text-subtle">Organic Electronics</span>
                    <div className="mt-0.5 flex items-baseline gap-2.5">
                        <span className="whitespace-nowrap text-heading font-extrabold leading-[1.1] tracking-[-0.02em] text-ink-secondary">
                            Unlock Everything
                        </span>
                        <span className="whitespace-nowrap text-r-body font-semibold text-subtle transition-colors duration-700 group-hover:text-white">
                            from {priceLabel} /mo
                        </span>
                    </div>
                </div>
                <span className="whitespace-nowrap border-b-[1.5px] border-ink-secondary/45 pb-0.5 text-r-item font-extrabold tracking-[-0.01em] text-ink-secondary">
                    Get All-Access
                </span>
            </div>
        </Link>
    );
}

export default AllAccessBanner;
